export const COMPANY = {
  name: "ISGS Asbestos Consulting",
  legalName: "ISGS Consulting Group Pty Ltd",
  shortName: "ISGS",
  tagline: "Trusted asbestos experts. NSW & Australia-wide.",
  phone: "0405 215 940",
  phoneAlt: "1800 47 48 49",
  phoneTel: "+61405215940",
  phoneAltTel: "+611800474849",
  whatsapp: "+61405215940",
  email: "admin@isgsasbestos.com.au",
  address: "PO Box 47, Narwee NSW 2209, Australia",
  hours: "Mon–Fri 7:00am – 5:00pm AEST",
  emergency: "24/7 Emergency Response",
  logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/xlou82sn_ISGS_Logo.jpg",
  logoMark: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/7zhhy5t4_Png-01.webp",
  brochure: "https://customer-assets.emergentagent.com/job_draft-preview-11/artifacts/upmiib2a_ISGS%20Brouchure.jpg",
};

// Social media URLs — replace placeholders with actual profile URLs when ready
export const SOCIALS = [
  { name: "LinkedIn", url: "https://www.linkedin.com/company/isgs-consulting-group", icon: "Linkedin" },
  { name: "Instagram", url: "https://www.instagram.com/isgs_consulting", icon: "Instagram" },
  { name: "Facebook", url: "https://www.facebook.com/isgsasbestos", icon: "Facebook" },
  { name: "TikTok", url: "https://www.tiktok.com/@isgsasbestos", icon: "TikTok" },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/health-effects", label: "Asbestos" },
  { to: "/projects", label: "Projects" },
  { to: "/resources", label: "Resources" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

export const SERVICES = [
  { title: "Asbestos Inspections & Assessments", desc: "On-site identification and risk-rated assessment of all suspected asbestos-containing materials, aligned with SafeWork NSW and federal frameworks.", icon: "ClipboardCheck" },
  { title: "HAZMAT Sampling & Testing", desc: "Asbestos, lead, mould and soil sampling — analysed exclusively through NATA-accredited laboratories for defensible results.", icon: "Microscope" },
  { title: "HAZMAT Compliance Reports", desc: "Detailed asbestos and hazmat reports with compliance notes, risk ratings and clear remediation pathways for clients and regulators.", icon: "FileSpreadsheet" },
  { title: "Air Quality Monitoring", desc: "Independent air monitoring before, during and after removal works to verify safe exposure levels and on-site air quality.", icon: "Cloud" },
  { title: "Clearance Inspections", desc: "Post-removal inspections and validation-based sampling, culminating in clearance certificates for safe re-occupation.", icon: "BadgeCheck" },
  { title: "Remedial Project Management", desc: "End-to-end management of asbestos and hazmat remediation — scope, contractors, compliance and reporting under one roof.", icon: "HardHat" },
  { title: "Independent Third Party Engagement Expertise", desc: "Impartial expert engagement on contested or complex matters — no conflict of interest, no removalist ties.", icon: "Handshake" },
  { title: "Asbestos Legal Representation", desc: "Expert technical opinion and reporting to support legal, insurance and dispute matters involving asbestos.", icon: "Scale" },
  { title: "Soil Contamination Reports", desc: "Investigation, sampling and remediation reporting for asbestos-impacted and contaminated soils across residential, commercial and public sites.", icon: "Sprout" },
  { title: "Emergency Response Works", desc: "24/7 rapid-response inspections and sampling for unexpected finds, fire damage and unforeseen hazmat exposures.", icon: "Siren" },
];

/*
 * PROJECT IMAGES — HOW TO ADD A PHOTO
 * ────────────────────────────────────
 * Each project has an `image` field. Two ways to set it:
 *   1. Paste any public image URL (e.g. https://your-host.com/image.jpg)
 *   2. Upload the photo via chat → I'll give you a permanent URL → paste it here
 *
 * Leave as empty string ("") to keep the elegant gradient placeholder.
 * Recommended size: 1200 × 900 px (4:3 ratio), under 500 KB.
 */
/**
 * Projects — Rotating snapshot of ISGS case studies.
 * Eight curated cases spanning heritage (Sydney Opera House), heritage-education
 * (Fort Street Public School), emergency fire-damage response (2024 & 2025),
 * Mr Fluffy loose-fill asbestos, environmental illegal-dumping (Royal National Park),
 * a TBA slot for the next release and 1 Martin Place commercial CBD hazmat.
 * Rotated periodically and augmented by Google Business Profile posts / reviews.
 * Image guide: 1200 × 900 px (4:3), under 500 KB.
 */
export const PROJECTS = [
  {
    id: 1,
    title: "Sydney Opera House — Heritage Asbestos Investigation",
    category: "Heritage Site",
    location: "Bennelong Point, NSW",
    year: "2016",
    summary:
      "Specialist material identification, sampling and laboratory testing of asbestos-containing elements at the Sydney Opera House — delivered under strict heritage-conservation and Aboriginal cultural-heritage protocols with full clearance certification and air monitoring.",
    services: ["Lead", "Asbestos", "Air Monitoring", "Sampling & Testing", "Clearance Certificates", "Heritage Protocols"],
    expertise: "Asbestos Subject Matter Experts",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/mmhwrdbw_Syd%20Opera%20House%20and%20Botanticals.jfif",
  },
  {
    id: 2,
    title: "Fort Street Public School — Heritage & Aboriginal Asbestos Management",
    category: "Education & Heritage",
    location: "Observatory Hill, NSW",
    year: "2022",
    summary:
      "Pre-build asbestos and lead survey, air monitoring and hazmat management plan for one of Sydney's oldest heritage-listed schools — Aboriginal cultural-heritage protocols observed and delivered to NSW Department of Education standards.",
    services: ["Site Inspection", "Management Plan", "Asbestos Register", "Lead Sampling", "Air Monitoring", "Aboriginal Heritage"],
    expertise: "Hazmat Specialists",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/mrhzxoln_Fort%20St%20Public%20School%20prebuild.webp",
  },
  {
    id: 3,
    title: "NSW Bush Fires — 2015 Emergency Hazmat Response",
    category: "Emergency Response",
    location: "NSW Bush Fires",
    year: "2015",
    summary:
      "Emergency hazmat response across NSW bush-fire-impacted properties in 2015 — same-day inspection and sampling of asbestos-containing debris, lead-paint residues and combustion by-products, enabling safe re-entry, insurance sign-off and reinstatement works for affected residents and insurers.",
    services: ["24/7 Emergency Inspection", "Hazmat Sampling", "Combustion Residue Testing", "Risk Assessment", "Insurance Reporting"],
    expertise: "Hazmat Specialists",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/13s31mz6_WhatsApp%20Image%202026-08-03%20at%205.10.23%20PM.jpeg",
  },
  {
    id: 4,
    title: "Mr Fluffy Loose-fill Asbestos — Residential Remediation",
    category: "Loose-fill Specialist",
    location: "Auburn & Greater Sydney, NSW",
    year: "2023",
    summary:
      "Residential Mr Fluffy loose-fill asbestos task-force programme — inspection and reporting, findings and clearances, controlled demolition oversight, sampling, laboratory testing, remediation reports and practical solutions for one of Australia's most hazardous asbestos forms.",
    services: ["Residential Inspection", "Findings & Clearances", "Demolition Oversight", "Sampling & Testing", "Remediation Reports", "Practical Solutions"],
    expertise: "Asbestos Subject Matter Experts",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/ki9vzlu2_2%20Loose%20fill%20asbestos%20insulation%20--%20Loose%20Fill%20Asbestos%20--%20256.jpg",
  },
  {
    id: 5,
    title: "Illegal Asbestos Dumping and Environmental Remediation — National Parks",
    category: "Environmental Remediation",
    location: "National Parks, NSW",
    year: "2025",
    summary:
      "End-to-end environmental response to illegal asbestos dumping in protected parkland — asbestos management plans, registers, sampling, inspections, remediations and action plans covering asbestos in soil, flora and fauna, with full environmental impact assessment.",
    services: ["Management Plans", "Asbestos Registers", "Sampling & Inspections", "Remediations", "Action Plans", "Asbestos in Soil", "Flora & Fauna", "Environmental Impact"],
    expertise: "Hazmat Specialists",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/ahljiiaf_EPA%20illegal%20dumping.jfif",
  },
  {
    id: 8,
    title: "Commercial CBD Heritage Hazmat incl. Lead, Silica & Asbestos-in-Putty Remediation — 1 Martin Place",
    category: "CBD / Heritage Commercial",
    location: "1 Martin Place, Sydney CBD",
    year: "2019",
    summary:
      "Comprehensive hazardous-materials programme across the historic 1 Martin Place building — lead-paint identification, respirable crystalline silica management, and specialist asbestos-in-putty investigation and controlled remediation. Management plans, registers, heritage findings and refurbishment support delivered under strict heritage-conservation protocols to inform sensitive fit-out works.",
    services: ["Asbestos in Putty Remediation", "Lead Investigation", "Silica Management", "Management Plans", "Registers", "Heritage Findings", "Refurbishment Support"],
    expertise: "Hazmat Specialists",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/v203la4u_1%20Martin%20Place.webp",
    rotate: true,
  },
  {
    id: 7,
    title: "Fire-Damaged Property — 2024 Emergency Hazmat Response",
    category: "Emergency Response",
    location: "Residential & Industrial, NSW",
    year: "2024",
    summary:
      "Earlier fire-damage engagement — rapid post-incident inspection and hazmat sampling covering asbestos-containing debris, lead-paint residues and combustion by-products, followed by clearance and reinstatement documentation for insurer and owner.",
    services: ["Emergency Inspection", "Debris Sampling", "Lead & Asbestos Testing", "Clearance", "Insurance Reporting"],
    expertise: "Hazmat Specialists",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/cs3jlaq9_WhatsApp%20Image%202026-08-03%20at%205.09.13%20PM.jpeg",
  },
  {
    id: 6,
    title: "Next Case Study — Coming Soon",
    category: "TBA",
    location: "NSW & Australia-wide",
    year: "TBA",
    summary:
      "A new case study is being prepared for release. Recent engagements span government infrastructure, cross-government heritage work and industrial hazmat programmes — updates published periodically alongside our Google Business Profile posts.",
    services: ["Coming Soon"],
    expertise: "Asbestos Subject Matter Experts",
    image: "",
  },
];

export const RESOURCES = [
  {
    name: "Safe Work Australia",
    type: "Link",
    brand: "Safe Work Australia",
    logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/8n6iqi76_image.png",
    url: "https://www.safeworkaustralia.gov.au/",
    description: "National WHS policy, model Codes of Practice and asbestos factsheets — including guidance on fire-damaged asbestos.",
  },
  {
    name: "ASEA — Asbestos Safety & Eradication Agency",
    type: "Link",
    brand: "ASEA",
    logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/qba3r0yq_image.png",
    url: "https://www.asbestossafety.gov.au/",
    description: "National Strategic Plan, Asbestos Exposure Register, NSW Heat Map and awareness resources.",
  },
  {
    name: "SafeWork NSW",
    type: "Link",
    brand: "SafeWork NSW",
    logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/jm2ophrl_image.png",
    url: "https://www.safework.nsw.gov.au/",
    description: "iVerify asbestos licence check, WHS Regulations and NSW asbestos guidance.",
  },
  {
    name: "ISGS Asbestos Consulting — Unexpected Finds Procedure",
    type: "PDF",
    attached: true,
    brand: "ISGS Asbestos Consulting",
    logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/7zhhy5t4_Png-01.webp",
    url: "https://customer-assets-eiarnc6j.emergentagent.net/job_draft-preview-11/artifacts/cqg244oz_Unexpected%20Finds%20Protocol%20Flow%20Chart%20w%20logo.jpg",
    description: "Step-by-step flow chart for the discovery of suspected asbestos on-site — PCBU responsibilities, containment and clearance.",
  },
];

export const STATS = [
  { value: "500+", label: "Projects Delivered" },
  { value: "18+", label: "Years Experience" },
  { value: "24/7", label: "Emergency Response" },
  { value: "NATA", label: "Accredited Labs" },
];

export const MEMBERSHIPS = ["ADRA", "AIOH", "ASEA", "EAF", "FAMANZ", "IIA"];

/*
 * TESTIMONIALS — HOW TO UPDATE
 * ─────────────────────────────
 * Sourced from the ISGS Consulting Group Google Business page.
 * To add or edit a review:
 *   1. Open your Google Business page
 *   2. Copy the review text and author name
 *   3. Paste into the entries below (keep rating: 5 and source: "Google")
 */
export const TESTIMONIALS = [
  {
    id: 1,
    rating: 5,
    quote:
      "Very good and thorough. Would definitely recommend everyone for their services.",
    author: "Daniel Mijanovic",
    role: "",
    source: "Google",
  },
  {
    id: 2,
    rating: 5,
    quote:
      "Quick, professional, excellent and very knowledgeable services. Highly recommend trying them out.",
    author: "Aayan Mazhar",
    role: "",
    source: "Google",
  },
  {
    id: 3,
    rating: 5,
    quote:
      "Team was compassionate and trustworthy. Hats off to the team. Really amazing.",
    author: "Melina Dawadi",
    role: "",
    source: "Google",
  },
];

export const CAREERS_EMAIL = "admin@isgsasbestos.com.au";

export const JOBS = [
  {
    id: "asbestos-assessor",
    title: "Licensed Asbestos Assessor",
    location: "Sydney, NSW",
    type: "Full-time",
    department: "Field Operations",
    summary:
      "Lead on-site asbestos inspections, sampling and risk assessments across residential, commercial and heritage sites. Class A or B Asbestos Assessor Licence required.",
    requirements: [
      "Class A or B Asbestos Assessor Licence (NSW)",
      "3+ years asbestos consulting / assessing experience",
      "Strong written reporting skills",
      "Current driver's licence",
    ],
  },
  {
    id: "occupational-hygienist",
    title: "Occupational Hygienist",
    location: "Sydney, NSW",
    type: "Full-time",
    department: "Air Monitoring",
    summary:
      "Conduct independent air monitoring during asbestos removal works, draft clearance certificates and contribute to hazmat management plans.",
    requirements: [
      "Tertiary qualification in occupational hygiene or related",
      "Experience with NATA-accredited air monitoring protocols",
      "AIOH membership preferred",
    ],
  },
  {
    id: "project-coordinator",
    title: "Asbestos Project Coordinator",
    location: "Sydney, NSW · Hybrid",
    type: "Full-time",
    department: "Project Management",
    summary:
      "Coordinate remediation projects end-to-end — scoping, scheduling licensed removalists, compliance documentation and client communications.",
    requirements: [
      "2+ years project coordination experience (construction or remediation)",
      "Familiarity with SafeWork NSW and ASEA frameworks",
      "Excellent stakeholder communication",
    ],
  },
  {
    id: "field-technician",
    title: "Field Technician / Trainee Assessor",
    location: "Sydney, NSW",
    type: "Full-time · Training Provided",
    department: "Field Operations",
    summary:
      "Entry-level role supporting senior assessors on inspections and sampling. Ideal pathway for those seeking to qualify as a licensed assessor.",
    requirements: [
      "Construction Induction (White Card)",
      "Physically able to access roofs, sub-floors and confined spaces",
      "Willingness to undertake assessor licensing pathway",
    ],
  },
];
